import {Injectable} from '@angular/core';
import {SERVER_API_URL} from 'app/app.constants';
import {HttpClient, HttpParams} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class PublicTrackingService {
    constructor(private _http: HttpClient) {}

    searchOrderForTracking = (searchValue, accessToken): Promise<any[]> => {
        let requestParams = new HttpParams().set('searchValue', searchValue);
        if (accessToken) {
            requestParams = requestParams.append('accessToken', accessToken);
        }
        return this._http.get<any[]>(`${SERVER_API_URL}api/public-tracking`, {params: requestParams}).toPromise();
    };
}
